import { func } from 'prop-types';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RadioGroup } from 'components';
import { addUuid } from 'helpers';

const AdhesionTypeStep = ({ changeStep }) => {
  const { t } = useTranslation();
  const {
    formState: { isValid },
    isLoading,
    submitClasses
  } = useFormContext();

  const radioOptions = useMemo(
    () =>
      addUuid(
        [
          {
            name: 'adhesionType',
            value: 'postalPensioner',
            content: () => (
              <div>
                <span>{t('auth:registration.steps.postalPensioner')}</span>
                <span className="text-yellow-500 mx-2">-</span>
                <span className="text-primary-500">{t('auth:registration.steps.yearPrice')}</span>
              </div>
            )
          },
          {
            name: 'adhesionType',
            value: 'orangeMember',
            content: () => (
              <div>
                <span>{t('auth:registration.steps.orangeMember')}</span>
                <span className="text-yellow-500 mx-2">-</span>
                <span className="text-primary-500">{t('auth:registration.steps.yearPrice')}</span>
              </div>
            )
          },
          {
            name: 'adhesionType',
            value: 'orangePensioner',
            content: () => (
              <div>
                <span>{t('auth:registration.steps.orangePensioner')}</span>
                <span className="text-yellow-500 mx-2">-</span>
                <span className="text-primary-500">{t('auth:registration.steps.yearPrice')}</span>
              </div>
            )
          }
        ],
        'adhesion-type-radio-'
      ),
    []
  );

  return (
    <>
      <RadioGroup
        radioOptions={radioOptions}
        rules={{ required: true }}
        groupLabel={t('auth:registration.steps.selectAdhesion')}
      />

      <button
        type="button"
        disabled={!isValid || isLoading}
        onClick={changeStep}
        className={submitClasses}
        data-test-id="adhesionTypeSubmitBtn"
      >
        {t('buttons.next')}
      </button>
    </>
  );
};

AdhesionTypeStep.propTypes = {
  changeStep: func.isRequired
};

export default AdhesionTypeStep;
